var path = 'common/breadcrumbs/breadcrumbs.html';
var html = "<ol class=ns-breadcrumbs><li ng-repeat=\"crumb in vm.crumbs\" class=ns-breadcrumbs__item><a ng-if=!$last ng-click=vm.followCrumb(crumb) class=ns-breadcrumbs__link>{{ crumb.name }}</a> <span ng-if=$last>{{ crumb.name }}</span></li></ol>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/breadcrumbs/breadcrumbs.html
 ** module id = 157
 ** module chunks = 0
 **/